export function getCSRFToken() {
  const e = document.querySelector('[name="csrf-token"]')
  if (e === null) { return "noCSRFTokenFound" }
  else { return e.content }
}

(function($, _undefined) {
  const rails = {
    /* Stolen from jquery-ujs/rails - we use turbo, so we don't want all the other stuff */

    // Up-to-date Cross-Site Request Forgery token
    csrfToken: function() {
      return $('meta[name=csrf-token]').attr('content');
    },

    // URL param that must contain the CSRF token
    csrfParam: function() {
      return $('meta[name=csrf-param]').attr('content');
    },

    // Make sure that every Ajax request sends the CSRF token
    CSRFProtection: function(xhr) {
      var token = rails.csrfToken();
      if (token) xhr.setRequestHeader('X-CSRF-Token', token);
    },
  }

  $.ajaxPrefilter(function(options, _originalOptions, xhr){ if ( !options.crossDomain ) { rails.CSRFProtection(xhr); }});
})( jQuery );
